import React from 'react'

const SubTitle = ({ title }) =>
  <h3>
    {title}
  </h3>

export default SubTitle



// WEBPACK FOOTER //
// ./src/components/SubTitle.js